import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import GroupOverview from "../components/child/GroupOverview";
const CenterGroupOverview = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Center Group" />

        <GroupOverview />

      </MasterLayout>
    </>
  );
};

export default CenterGroupOverview;
